import { Component, Input, input } from '@angular/core';
import { Image } from '@frontend/core';


@Component({
  selector: 'frontend-media-image',
  templateUrl: './media-image.component.html',
  styleUrls: ['./media-image.component.scss'],

  standalone: false,
})
export class MediaImageComponent {

  @Input() classes: string;
  @Input() transformations: string; // Cloudinary transformation string (applied only for cloudinary-disk images)
  image = input<Image>();
  @Input() altText: string;
  @Input() altTextTranslation: string; // 'common.log_in' // ****NOT**** currently supported. It will not parse in the template!

  constructor() { }

}
